// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
// baseurl: "https://localhost:44342/api/",
 //PROD
  baseurl: "http://api.stratton-maes.eu/api/",
  //UAT
 // baseurl: "http://89.36.74.86:44502/api/",
  MasterToken: "eD6hoAHM5u6z6H9K7Qv0r7HATcKoHeIfH4ysVLs2VfhgxktED8M0gQ=="
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
//http://89.36.74.86:44502/swagger/index.html